<template>
  <div style="padding-bottom: 60px;">
    <div class="buyVip-content flex">
      <div class="buyVip-view padding-left-buyVip" style="font-size: 20px;" v-if="VERSIONS">
        <div class="solids-left line-black padding-left-sm text-600">
          购买下载额度
          <span class="text-gray text-df margin-left-xl text-400">原价{{traffic.originAmount/100}}元/G  活动价{{traffic.amount/100}}元/G</span>
        </div>
        <div class="text-lg text-orange margin-top-xxl">{{hasShowTrafficUser?'当前活动属于以下账户，购买后充值到以下账号，请确认无误后购买；也可联系活动发起人购买':'&nbsp;'}}</div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 20px;">
          <div style="min-width: 90px;">账号名称：</div>
          <div style="font-size: 24px;">{{trafficUser.userName||''}}</div>
        </div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 40px;">下载额度：
          <el-input-number v-model="num" @change="numChange" :min="1" :max="99999"></el-input-number>
          <div style="font-size: 24px;" class="margin-left-sm">
            G
          </div>
        </div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 40px;">支付方式：
          <div class="wechat-pay-icon margin-right-sm"></div>
          <div class="text-400">微信支付</div>
        </div>
        <div class="flex align-end text-xl text-500 margin-right-xs" style="margin-top: 40px;height: 23px;">会员折扣：
          <div style="font-size: 18px;color: #9F7438;height: 25px;">当前版本为{{VERSIONS[trafficUser.vipType].versionName}}：{{trafficUser.vipType==0?'无折扣':('享'+discount(VERSIONS[trafficUser.vipType].discount)+'折优惠')}}</div>
        </div>
      </div>
      <div class="buyVip-view padding-left-buyVip padding-right-buyVip solids-left" style="font-size: 20px;" v-if="downloadTrafficAmount">
        <div class="line-black padding-left-sm text-600" style="color: transparent;">
          购买下载额度
        </div>
        <div class="text-lg text-orange margin-top-xxl" style="color: transparent;">{{hasShowTrafficUser?'当前活动属于以下账户，购买后充值到以下账号，请确认无误后购买；也可联系活动发起人购买':'&nbsp;'}}</div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 20px;">
          <div style="min-width: 90px;">订单原价：</div>
          <div style="font-size: 24px;">¥{{downloadTrafficAmount.originalAmount/100}}</div>
        </div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 40px;">立减金额：
          <div style="font-size: 24px;">-¥{{downloadTrafficAmount.discountList[0].amount/100}}</div>
        </div>
        <div class="flex align-center text-xl text-500 margin-right-xs" style="margin-top: 40px;">{{trafficUser.vipType==0?'无折扣':('会员折扣'+discount(downloadTrafficAmount.discountList[1].discount)+'折')}}：
          <div style="font-size: 24px;">-¥{{downloadTrafficAmount.discountList[1].amount/100}}</div>
        </div>
        <div class="flex align-end text-xl text-500 margin-right-xs" style="margin-top: 40px;height: 23px;">应付金额：
          <div style="font-size: 30px;color: #ff6800;height: 30px;">¥ {{downloadTrafficAmount.currentAmount/100}}</div>
        </div>
        <div class="flex align-center justify-end text-xl" style="margin-top: 100px;">
          <button class="cu-btn bg-green padding-tb-xl radius padding-lr-xxxl text-xxl text-500" @click="showPaycode">确定支付</button>
        </div>
      </div>

    </div>
    <div class="buyVip-content text-gray" style="margin-top: 50px; border-width: 0;background: none;">
      <div class="buyVip-view" style="padding: 0; ">
        <div>售前说明：</div>
        <div>1、下载全部为按次、按文件大小收费，下载文件为源文件（上传时的文件）；</div>
        <div>2、收费标准：下载额度单独付费原价{{traffic.originAmount/100}}元/G,活动价{{traffic.amount/100}}元/G；</div>
        <div>3、打包下载文件，付费后，需要先打包，打包完成后，通过短信/公众号消息告知下载进度；</div>
        <div>4、付费下载额度，支付成功后，即时生效，可重复购买；下载额度使用后或过期后不支持退款；</div>
      </div>
    </div>
    <dialogCode ref="dialogCode"></dialogCode>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import dialogCode from './components/checkout/dialogCode.vue'
  import ElInput from "../../node_modules/element-ui/packages/input/src/input.vue";
  import ElInputNumber from "../../node_modules/element-ui/packages/input-number/src/input-number.vue";
  export default {
    data () {
      return {
        activityId:'',
        activityName:'',
        num:1,
        traffic:{
          amount:0,
          originAmount:0,
        },//单价
        trafficUser:{},
        hasShowTrafficUser:false,
        downloadTrafficAmount:null,
        VERSIONS:null,
      }
    },
    components:{
      ElInputNumber,
      ElInput,
      dialogCode,
    },
    methods:{
      getlist(){
        //activityId=16443&activityName=fix
        this.activityId=this.$route.query.activityId
        this.activityName=this.$route.query.activityName

        App.demand('/activity/payment/queryPayServiceItemList','POST',{
          pageIndex: 1,
          pageSize: 100,
          serviceKey: 'userdownloadtraffic',
          //paymentType : "vip",
        }).then(res=>{
          this.traffic=res.data.list[0]
          let num=1
          if(this.$route.query.size){
            num=Math.ceil(this.$route.query.size/1024/1024/1024)
            num=num<1?1:num
          }
          this.numChange(num)
        })
      },
      showPaycode(){
        //console.log('this.vips[this.chooseVipsIdx]',this.vips[this.chooseVipsIdx],this.vips)
        if(!(this.traffic.amount>0 && this.num>0)) return;
        this.$refs.dialogCode.show({
          amount:this.downloadTrafficAmount.currentAmount,
          count:this.num,
          serviceKey:this.traffic.serviceKey,
          trafficUser:this.trafficUser,
        })
      },
      numChange(num){
        this.num=num
        App.demand('/activity/payment/queryDownloadTrafficAmount','POST',{
          //"activityId": this.activityId,
          "count": this.num,
          "serviceKey": this.traffic.serviceKey,
          "tradeType": 2,
          "userId": this.trafficUser.id,
        }).then(res=>{
          this.downloadTrafficAmount=res.data
        })
      },
      getTrafficUser(){
        let userId=wxlite.getStorageSync('userId')
        //console.error(userId)
        App.demand('/user/info','GET',{
          userId:this.$route.query.userId?this.$route.query.userId:userId,
        }).then(res=>{
          this.trafficUser=res.data
          this.hasShowTrafficUser=userId!=this.trafficUser.id
          this.getlist();
        })
      },
      async getVersion(){
        let vds=(await App.demand('/activity/version/loadConfigList','GET')).data;
        let vers={};
        vds.forEach(ver=>{
          vers[ver.versionType]=ver
        });
        this.VERSIONS=vers
        ////////
        //discount 折扣字段
      },
      discount(discount){
        if(!discount) return ''
        return ((discount*10)+'').replace(/\./g,'')
      },
    },
    mounted(){
      this.getTrafficUser()
      this.getVersion()
    },

  }
</script>

<style>
  .buyVip-content{
    width: calc(100% - 40px);
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fefefe;
    border: 1px solid #979797;
    border-radius: 2px;
  }
  .buyVip-view{
    max-width: 1160px;
    margin: 0 auto;
    padding: 40px 0 60px;
    width: 100%;
  }

  .wechat-pay-icon{
    width: 30px;
    height: 26px;
    background-image: url("https://assets.pfotoo.com/pc/pay%20(1).png");
    background-size: 100% 100%;
  }
  .buyVip-view.padding-left-buyVip{
    padding-left: 8%!important;
  }
  .buyVip-view.padding-right-buyVip{
    padding-right: 5%!important;
  }
</style>


// WEBPACK FOOTER //
// src/pages/buyTraffic.vue